import React, {useContext} from "react";
import "./RecentTrackCard.css";
import { getStageStyles } from "../../../Common/Common-Function/CommonFunctions";
import Button from "../../../Common/Button/Button";
import calendarIcon from "../../../Assets/Images/calendarIcon.png";
import darkCalendarIcon from "../../../Assets/Images/calendar-dark-Icon.png";
import dashboardClock from "../../../Assets/Images/dashboardClock.png";
import darkDashboardClock from "../../../Assets/Images/dashboard-dark-Clock.png";
import { DynamicContext } from "../../../Context/DynamicContext";
import ActiveCandidateIcon from "../../../Assets/Images/active-candidate-icon.svg";
import mailIcon from "../../../Assets/Images/mail_icon.svg";
import phoneIcon from "../../../Assets/Images/phone_icon.svg";

const RecentTrackCard = React.forwardRef(function RecentTrackCard(
  { candidateName,candidateEmail,candidatePhone, date, time, firstName, lastName, stage, candidateId, viewEvent = () => "" },
  ref
) {
  const { isDarkMode, userDetails ,AdminAccess} = useContext(DynamicContext);
   const handleViewClick = () => {
    if (candidateId && viewEvent) {
      viewEvent(candidateId);
    }
  };
  return (
    <div ref={ref} className="track-card">
      <div className="track-card-left">
         <span className="track-candidate-name" style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "3px" }}>
          <span className="candidate-icon-img"><img
            src={ActiveCandidateIcon}
            alt="Candidate Icon"
          /></span><span className="candidate-name-text">{candidateName}</span></span>

           <span className="track-candidate-name" style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "3px" }}>
          <span className="candidate-icon-img"><img
            src={mailIcon}
            alt="Candidate Icon"
          /></span><span className="candidate-name-text">{candidateEmail}</span></span>

           <span className="track-candidate-name" style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "3px" }}>
          <span className="candidate-icon-img"><img
            src={phoneIcon}
            alt="Candidate Icon"
          /></span><span className="candidate-name-text">{candidatePhone}</span></span>

        <div className="date-container-wrapper">
          <div className="date-container" style={{alignItems: 'center', marginTop: '-5px'}}>
            <img alt="" src={isDarkMode ? darkCalendarIcon : calendarIcon} className="recent-history-icons"/> <span className="track-date">{date}</span>
          </div>
          <div className="date-container" style={{alignItems: 'center', marginTop: '-5px'}}>
            <img alt="" src={isDarkMode ? darkDashboardClock : dashboardClock} className="recent-history-icons"/> <span className="track-date">{time}</span>
          </div>
        </div>
        {AdminAccess && firstName && lastName && (
          <div className="date-container" style={{marginTop: '15px', color: 'var(--header-color)', fontWeight: '500',marginLeft: '7px'}}>
            <span>Recruiter: {firstName + " " + lastName}</span>
          </div>
        )}
      </div>
      <div className="track-card-right">
        <span className="recent-track-stage" style={getStageStyles(stage)}>{stage}</span>
        <div className="track-view-container">
          <Button
            label="View"
            event={handleViewClick}
            className="view"
            backgroundColor="var(--cards-background)"
            color="#6860EE"
            border="1px solid #6860EE"
            style={{ padding: "8px 12px", marginTop: "90px" }}
          />
        </div>
      </div>
    </div>
  );
});

export default RecentTrackCard;